import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('jwtToken'));
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('userInfo');
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    if (token) localStorage.setItem('jwtToken', token);
    else localStorage.removeItem('jwtToken');
  }, [token]);

  useEffect(() => {
    if (user) localStorage.setItem('userInfo', JSON.stringify(user));
    else localStorage.removeItem('userInfo');
  }, [user]);

  const login = (jwt, userInfo) => {
    setToken(jwt);
    setUser(userInfo);
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('userInfo');
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext); 